module.exports = __webpack_public_path__ + "static/media/filter_icon.69ddce6a.svg";